const RaLayout = (palette) => ({
  styleOverrides: {
    root: {
      color: palette.dark.main
    }
  }
});

export default RaLayout;
